// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/bol/emoji.css
// module id = 579
// module chunks = 0